module.exports = __webpack_public_path__ + "static/media/logoV.40690622.svg";